import React from 'react';
import "./layout.css";
import Notifications from "../../modules/notifications/notifications-container";
import {connect} from "react-redux";
import {hideContextMenu} from "../../modules/context-menu/context-menu-action-creators";

const Layout = ({ children, hideContextMenu }) => (
  <div
    className="layout_container"
    onClick={hideContextMenu}
  >
    <Notifications />
    { children }
  </div>
);


const mapDispatchToProps = dispatch => ({
  hideContextMenu: () => dispatch(hideContextMenu())
});

export default connect(null, mapDispatchToProps)(Layout);


// WEBPACK FOOTER //
// ./src/components/layout/layout-component.js